import type { ConnectedWallet } from "../types";
import type { WalletPsbtRequest } from "../wallets";

export interface LocalWalletAdapter {
  assertSelected: () => void;
  signMessage: (address: string, message: string) => Promise<string>;
  signTransactions: (requests: WalletPsbtRequest[], message: string) => Promise<Record<string, string>>;
}
// Bound to the actual in-memory wallet object. No window provider, keys, or session tokens
// are exposed to website frames, extensions, or persisted external-wallet state.
const adapters = new WeakMap<object, LocalWalletAdapter>();
export function registerLocalWallet(wallet: ConnectedWallet, adapter: LocalWalletAdapter): () => void {
  if (wallet.provider !== "stc") throw new Error("Expected an STC local wallet");
  adapters.set(wallet, adapter);
  return () => { if (adapters.get(wallet) === adapter) adapters.delete(wallet); };
}
export function localWalletAdapter(wallet: object): LocalWalletAdapter {
  const adapter = adapters.get(wallet);
  if (!adapter) throw new Error("STC Wallet is locked or this app connection has closed.");
  adapter.assertSelected(); return adapter;
}
